import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { getMaxNumberByKey } from 'utilitys/helpers/general';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';
import { useProjectTreeStore } from 'store/projectContract.store';

export const PageWidgetWrapper = ({ children }) => {
    const hashcode = Object.values(useParams()).filter(Boolean).join(',');
    const { project, contract } = useProjectTreeStore();
    const projectId = project?.id;
    const contractId = contract?.id;

    const { versionList: versionFromHashMap } = useHashmapConverter(hashcode);
    const latestVersionId = versionFromHashMap[0]?.versionDbId;
    const compareVersionId = versionFromHashMap[1]?.versionDbId;
    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);
    const maxLevel = useMemo(
        () => getMaxNumberByKey({ list: versionFromHashMap, key: 'maxLevel' }),
        [versionFromHashMap],
    );

    return React.Children.map(children, (child) => {
        return child
            ? React.cloneElement(child, {
                  projectId,
                  contractId,
                  latestVersionId,
                  compareVersionId,
                  globalFilterData,
                  maxLevel,
              })
            : null;
    });
};
